import './globals.ts'

import ReactJSXRuntime from 'react/jsx-runtime'

// @ts-ignore
export const Fragment = ReactJSXRuntime.Fragment
// @ts-ignore
export const jsx = ReactJSXRuntime.jsx
// @ts-ignore
export const jsxs = ReactJSXRuntime.jsxs
// @ts-ignore
export const jsxDEV = ReactJSXRuntime.jsx
